import { FormControl } from "@angular/forms";

export function phoneNumberValidator (intlTelInput: any) {
  return (control: FormControl) => {
    if (!control || !intlTelInput) {
      return null;
    }
    return intlTelInput.isValidNumber()
      ? null
      : { "phoneInvalid": { "value": control.value } };
  };
}
